import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { Feedback } from '../types';
import { useUser } from '../contexts/UserContext';
import { subscribeToFeedback } from '../firebase/firestore';
import { cn } from '../utils/cn';

interface NotificationBadgeProps {
  className?: string;
  showIcon?: boolean;
}

export function NotificationBadge({ className = '', showIcon = true }: NotificationBadgeProps) {
  const { isAdmin } = useUser();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!isAdmin) return;

    const unsubscribe = subscribeToFeedback((feedbacks: Feedback[]) => {
      const unread = feedbacks.filter(feedback => !feedback.isReadByAdmin).length;
      setUnreadCount(unread);
    });

    return () => unsubscribe();
  }, [isAdmin]);

  if (!isAdmin || unreadCount === 0) {
    return null;
  }

  return (
    <div className={`${showIcon ? 'relative' : 'inline-flex items-center'} ${className}`}>
      {showIcon && <Bell className="w-5 h-5 text-gray-600" />}
      <span className={cn(
        "text-xs font-semibold animate-pulse",
        showIcon 
          ? "absolute -top-2 -right-2 bg-red-500 text-white rounded-full h-5 w-5 flex items-center justify-center"
          : "bg-red-500 text-white rounded-full px-2 py-1 inline-flex items-center justify-center"
      )}>
        {unreadCount > 99 ? '99+' : unreadCount}
      </span>
    </div>
  );
}
